<div class="container">
  <div class="user-meet-balance" *ngIf="!loading else this.loadingTemplate">
    <h2 class="user-meet-balance__title" i18n>Tus créditos disponibles</h2>

    <div *ngIf="balances?.length > 0; else noCredits" class="bhavani-cards">
      <div *ngFor="let balance of balances" class="dakkini-card bhavani-card">
        <h4 class="bhavani-card__title">{{ balance?.meet?.name?.toUpperCase() }}</h4>
        <p class="bhavani-card__coach">
          {{ balance?.coach?.name }} {{ balance?.coach?.lastname }}
        </p>
        <p class="bhavani-card__text" i18n>
          Tienes <strong>{{ balance.available }}</strong> llamadas disponibles para agendar con tu especialista con una
          duración de
          <strong>{{ balance?.meet?.duration || '---' }} minutos</strong>.
        </p>
        <a class="bhavani-card__cta" [routerLink]="['/platform/schedule', balance?.coach?.id, 'appointments', '.']" [queryParams]="{ session_type: balance?.meet?.name, modality: 'virtual'}" i18n>Agendar ahora</a>
      </div>
    </div>


    <div class="bhavani-balance-section__follow-up-offer texture_secondary">
      <h3 class="bhavani-balance-section__follow-up-title" i18n>¿Quieres más sesiones de seguimiento?</h3>
      <p class="bhavani-balance-section__follow-up-text" i18n>
        Potencia tu progreso y asegura el acompañamiento continuo de tu especialista. Adquiere un paquete de llamadas de seguimiento y continúa avanzando hacia tus objetivos.
      </p>
      <a
        class="bhavani-balance-section__follow-up-button"
        [routerLink]="['/platform/follow-up/plans']" i18n
      >
        Ver paquetes de seguimiento
    </a>
    </div>

  </div>
</div>

<ng-template #noCredits>
  <div class="user-meet-balance__no-credits">
    <h3 class="user-meet-balance__no-credits-title" i18n>No tienes créditos disponibles</h3>
    <p class="user-meet-balance__no-credits-text" i18n>
      Para continuar con tu seguimiento y aprovechar el acompañamiento de nuestros coaches, puedes adquirir un
      paquete de sesiones.
    </p>
    <button class="user-meet-balance__no-credits-button" [routerLink]="['/platform/follow-up/plans/.']" i18n>
      Ver paquetes de seguimiento
    </button>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <loading-dots-component></loading-dots-component>
</ng-template>